import { useMemo } from 'react';
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
const fetchPastMabExperiments = ({
  isLandingPage,
  contentId
}) => {
  return http.get(`cospages/v2/${isLandingPage ? 'landing' : 'site'}-pages/${contentId}/mab-get-past-experiments`).then(experiments => {
    return experiments.map(({
      master,
      variants,
      mabExperiment
    }) => {
      const allVariants = [master, ...variants];
      const allVariantsMap = allVariants.reduce((acc, variant) => {
        acc[variant.id] = variant;
        return acc;
      }, {});
      const allVariantsList = allVariants.map(({
        id,
        name
      }) => ({
        id,
        name
      }));
      return {
        mabVariantsMap: allVariantsMap,
        mabVariantsList: allVariantsList,
        mabExperiment: Object.assign({}, mabExperiment, {
          metric: 'submissionsPerPageview'
        })
      };
    });
  });
};
const MabPastExperimentsQuery = registerQuery({
  fieldName: 'mabPastExperiments',
  fetcher: fetchPastMabExperiments,
  args: ['isLandingPage', 'contentId']
});
const useMabPastExperiments = ({
  contentId,
  isLandingPage
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(MabPastExperimentsQuery, {
    variables: {
      contentId,
      isLandingPage
    }
  });
  return useMemo(() => ({
    mabPastExperiments: data === null || data === void 0 ? void 0 : data.mabPastExperiments,
    mabPastExperimentsRequestLoading: loading,
    mabPastExperimentsRequestError: error
  }), [data, error, loading]);
};
export default useMabPastExperiments;